export default "__VITE_ASSET__BAGH8Eow__"